import { TRUST } from "../data/site";

const ITEMS = [
  { label: "Google Reviews", value: TRUST.reviews },
  { label: "Average Rating", value: `${TRUST.rating}/5` },
  { label: "Years Experience", value: TRUST.experience },
  { label: "Clinic Locations", value: TRUST.locations },
  { label: "Procedures / Year", value: "1,500+" },
];

export default function TrustBar() {
  return (
    <section
      data-testid="trust-bar"
      className="border-y border-black/10 bg-[#fbfaf7]"
    >
      <div className="container-x grid grid-cols-2 md:grid-cols-5 divide-x divide-black/10">
        {ITEMS.map((it, i) => (
          <div
            key={it.label}
            data-testid={`trust-item-${i}`}
            className="py-7 md:py-8 px-4 md:px-6 first:pl-0 last:pr-0 flex flex-col items-start"
          >
            <div className="font-serif-display text-3xl md:text-4xl leading-none">
              {it.value}
            </div>
            <div className="mt-2 text-[11px] md:text-[12px] tracking-[0.18em] uppercase text-black/55 font-semibold">
              {it.label}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
